 import React, { useEffect, useState } from "react";
import Swal from 'sweetalert2';
import { API_URL } from "./config";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const MinistryProfile = () => {
    const navigate = useNavigate();
    const [ministry, setMinistry] = useState({
        id: "",
        name: "",
        description: "",
        detailedDescription: "",
        mission: "",
        meetingSchedule: "",
        activities: "",
        requirements: "",
        leaders: [],
        joined: false,
        dateJoined: null,
    });

    const memberId = localStorage.getItem("UserID");
    const ministryObj = localStorage.getItem("selectedMinistry");
    const rec = JSON.parse(ministryObj);
    const ministryId = rec.id;

    const handleJoin = async () => {
        try {
            let joinResponse = await fetch(`${API_URL}/ministrymembers/join`, {
                method: "post",
                body: JSON.stringify({
                    MemberID: memberId,
                    MinistryID: ministryId,
                }),
                headers: {
                    "Content-Type": "application/json",
                },
            });

            let approveResJson = await joinResponse.json();
            console.log(approveResJson);
            Swal.fire({ text: "Request to submitted!" });
            navigate(`/home`);
        } catch {
            Swal.fire({ text: "Error sending request, check your network connection", icon: "error" });
        }
    };

    const handleLeave = async () => {
        try {
            let joinResponse = await fetch(
                `${API_URL}/ministrymembers/reqleave/${memberId}/${ministryId}`,
                {
                    method: "put",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            let approveResJson = await joinResponse.json();
            console.log(approveResJson);
            navigate(`/home`);
        } catch {
            Swal.fire({ text: "Request to leave sent!", icon: "success" });
        }
    };

    const loadData = async () => {
        try {
            const data = localStorage.getItem("selectedMinistry");
            if (data) { 
                const parsed = JSON.parse(data);
                console.log(parsed);
                setMinistry({
                    ...parsed,
                    // Sample detailed data - in a real app this would come from your API
                    detailedDescription: parsed.detailedDescription
                });
            }
        } catch (error) {
            console.error("Loading error:", error);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    return (
        <div style={{ padding: '18px', marginBottom: '60px', backgroundColor: '#fff', minHeight: '100vh' }}>
            {/* Header with Back Button */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                marginBottom: '15px',
                position: 'relative'
            }}>
                <button
                    onClick={() => navigate(-1)}
                    style={{
                        backgroundColor: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '8px',
                        borderRadius: '50%',
                        marginRight: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'background-color 0.2s ease',
                        ':hover': {
                            backgroundColor: '#f0f2f5'
                        }
                    }}
                >
                    <ArrowBackIcon style={{ color: '#1a6363', fontSize: '28px' }} />
                </button>
                <h4 style={{
                    flex: 1,
                    textAlign: 'center',
                    fontSize: '19px',
                    color: '#1a6363',
                    fontWeight: '600',
                    margin: 0,
                    paddingRight: '52px'
                }}>
                    Ministry Profile
                </h4>
            </div>

            {/* Ministry Content */}
            <div style={{
                border: '1px solid #1a6363',
                borderRadius: '10px',
                padding: '15px',
                margin: '10px auto',
                maxWidth: '500px',
                backgroundColor: '#f9f9f9',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            }}>
                <h5 style={{ 
                    margin: '0', 
                    fontSize: '18px', 
                    color: '#ffffff', 
                    backgroundColor: '#1a6363', 
                    padding: '12px', 
                    borderRadius: '5px',
                    textAlign: 'center'
                }}>
                    {ministry.name} Ministry
                </h5>
                
                {/* Ministry Overview */}
                <div style={{ margin: '15px 0' }}>
                    <h6 style={{ 
                        color: '#1a6363', 
                        marginBottom: '8px', 
                        fontSize: '16px',
                        borderBottom: '1px solid #1a6363',
                        paddingBottom: '5px'
                    }}>
                        Overview
                    </h6>
                    <p style={{ 
                        margin: '8px 0', 
                        fontSize: '14px', 
                        color: '#555',
                        lineHeight: '1.5'
                    }}>
                        {ministry.detailedDescription}
                    </p>
                </div>
                               
                {/* Leaders Section */}
                <div style={{ margin: '15px 0' }}>
                    <h6 style={{ 
                        color: '#1a6363', 
                        marginBottom: '8px', 
                        fontSize: '16px',
                        borderBottom: '1px solid #1a6363',
                        paddingBottom: '5px'
                    }}>
                        Ministry Leaders
                    </h6>
                    {ministry.leaders?.map((item) => (
                        <div key={item.leaderID} style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            marginBottom: "12px",
                        }}>
                            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                <span style={{
                                    fontFamily: "Arial, sans-serif",
                                    fontSize: "15px",
                                    color: "#1a6363",
                                    fontWeight: 500
                                }}>
                                    {item.admin}
                                </span>
                            </div>
                            <span style={{
                                fontFamily: "Arial, sans-serif",
                                fontSize: "14px",
                                color: "#555",
                                marginTop: "4px"
                            }}>
                                Contact: {item.adminphone}
                            </span>
                        </div>
                    ))}
                </div>
                
                {/* Action Buttons */}
                <div style={{ marginTop: '20px' }}>
                    {ministry.joined ? (
                        <button onClick={handleLeave} style={{
                            backgroundColor: '#ff4d4d',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '5px',
                            padding: '12px 20px',
                            cursor: 'pointer',
                            width: '100%',
                            fontSize: '15px',
                            fontWeight: '500'
                        }}>
                            Request to Leave Ministry
                        </button>
                    ) : ministry.pendingJoin ? (
                        <button style={{
                            backgroundColor: '#1a6363',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '5px',
                            padding: '12px 20px',
                            cursor: 'pointer',
                            width: '100%',
                            opacity: 0.7,
                            fontSize: '15px',
                            fontWeight: '500'
                        }}>
                            Join Request Pending
                        </button>
                    ) : ministry.PendingLeave ? (
                        <button style={{
                            backgroundColor: '#1a6363',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '5px',
                            padding: '12px 20px',
                            cursor: 'pointer',
                            width: '100%',
                            opacity: 0.7,
                            fontSize: '15px',
                            fontWeight: '500'
                        }}>
                            Leave Request Pending
                        </button>
                    ) : (
                        <button onClick={handleJoin} style={{
                            backgroundColor: '#1a6363',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '5px',
                            padding: '12px 20px',
                            cursor: 'pointer',
                            width: '100%',
                            fontSize: '15px',
                            fontWeight: '500'
                        }}>
                            Join This Ministry
                        </button>
                    )}            
                </div>
            </div>
        </div>
    );
};

export default MinistryProfile;





//  import React, { useEffect, useState } from "react";
// import Swal from 'sweetalert2';
// import { API_URL } from "./config";
// import { useNavigate } from "react-router-dom";
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';

// const MinistryProfile = () => {
//     const navigate = useNavigate();
//     const [ministry, setMinistry] = useState({
//         id: "",
//         name: "",
//         description: "",
//         detailedDescription: "",
//         mission: "",
//         meetingSchedule: "",
//         activities: "",
//         requirements: "",
//         leaders: [],
//         joined: false,
//         dateJoined: null,
//     });

//     const memberId = localStorage.getItem("UserID");
//     const ministryObj = localStorage.getItem("selectedMinistry");
//     const rec = JSON.parse(ministryObj);
//     const ministryId = rec.id;

//     const handleJoin = async () => {
//         try {
//             let joinResponse = await fetch(`${API_URL}/ministrymembers/join`, {
//                 method: "post",
//                 body: JSON.stringify({
//                     MemberID: memberId,
//                     MinistryID: ministryId,
//                 }),
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//             });

//             let approveResJson = await joinResponse.json();
//             console.log(approveResJson);
//             Swal.fire({ text: "Request to submitted!" });
//             navigate(`/home`);
//         } catch {
//             Swal.fire({ text: "Error sending request, check your network connection", icon: "error" });
//         }
//     };

//     const handleLeave = async () => {
//         try {
//             let joinResponse = await fetch(
//                 `${API_URL}/ministrymembers/reqleave/${memberId}/${ministryId}`,
//                 {
//                     method: "put",
//                     headers: {
//                         "Content-Type": "application/json",
//                     },
//                 }
//             );

//             let approveResJson = await joinResponse.json();
//             console.log(approveResJson);
//             navigate(`/home`);
//         } catch {
//             Swal.fire({ text: "Request to leave sent!", icon: "success" });
//         }
//     };

//     const loadData = async () => {
//         try {
//             const data = localStorage.getItem("selectedMinistry");
//             if (data) { 
//                 const parsed = JSON.parse(data);
//                 console.log(parsed);
//                 setMinistry({
//                     ...parsed,
//                     // Sample detailed data - in a real app this would come from your API
//                     detailedDescription: parsed.detailedDescription || "The " + parsed.name + " is a vibrant community within our church dedicated to serving God through " + 
//                     (parsed.description || "various spiritual and practical activities").toLowerCase() + ". Our ministry was established with the vision to create " +
//                     "a space where members can grow in faith, develop their spiritual gifts, and make a meaningful impact in our church and community. " +
//                     "We believe that every member has unique talents given by God, and our ministry provides the perfect platform to discover and " +
//                     "utilize these gifts for His glory.",
                    
//                     mission: parsed.mission || "To empower believers through spiritual growth, service opportunities, and community building, " +
//                     "while fostering an environment of love, support, and discipleship in accordance with biblical principles.",
                    
//                     meetingSchedule: parsed.meetingSchedule || "We meet every Tuesday at 7:00 PM in the church annex building, " +
//                     "with additional special gatherings on the first Saturday of each month for outreach activities.",
                    
//                     activities: parsed.activities || "• Weekly Bible study and prayer meetings\n" +
//                     "• Monthly community outreach programs\n" +
//                     "• Annual spiritual retreat\n" +
//                     "• Seasonal worship nights\n" +
//                     "• Mentorship programs for new believers",
                    
//                     requirements: parsed.requirements || "• A committed relationship with Christ\n" +
//                     "• Willingness to serve and participate regularly\n" +
//                     "• Completion of new members orientation (for first-time participants)\n" +
//                     "• Agreement with our ministry's vision and values"
//                 });
//             }
//         } catch (error) {
//             console.error("Loading error:", error);
//         }
//     };

//     useEffect(() => {
//         loadData();
//     }, []);

//     return (
//         <div style={{ padding: '18px', marginBottom: '60px', backgroundColor: '#fff', minHeight: '100vh' }}>
//             {/* Header with Back Button */}
//             <div style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 width: '100%',
//                 marginBottom: '15px',
//                 position: 'relative'
//             }}>
//                 <button
//                     onClick={() => navigate(-1)}
//                     style={{
//                         backgroundColor: 'transparent',
//                         border: 'none',
//                         cursor: 'pointer',
//                         padding: '8px',
//                         borderRadius: '50%',
//                         marginRight: '24px',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         transition: 'background-color 0.2s ease',
//                         ':hover': {
//                             backgroundColor: '#f0f2f5'
//                         }
//                     }}
//                 >
//                     <ArrowBackIcon style={{ color: '#1a6363', fontSize: '28px' }} />
//                 </button>
//                 <h4 style={{
//                     flex: 1,
//                     textAlign: 'center',
//                     fontSize: '19px',
//                     color: '#1a6363',
//                     fontWeight: '600',
//                     margin: 0,
//                     paddingRight: '52px'
//                 }}>
//                     Ministry Profile
//                 </h4>
//             </div>

//             {/* Ministry Content */}
//             <div style={{
//                 border: '1px solid #1a6363',
//                 borderRadius: '10px',
//                 padding: '15px',
//                 margin: '10px auto',
//                 maxWidth: '500px',
//                 backgroundColor: '#f9f9f9',
//                 boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
//             }}>
//                 <h5 style={{ 
//                     margin: '0', 
//                     fontSize: '18px', 
//                     color: '#ffffff', 
//                     backgroundColor: '#1a6363', 
//                     padding: '12px', 
//                     borderRadius: '5px',
//                     textAlign: 'center'
//                 }}>
//                     {ministry.name} Ministry
//                 </h5>
                
//                 {/* Ministry Overview */}
//                 <div style={{ margin: '15px 0' }}>
//                     <h6 style={{ 
//                         color: '#1a6363', 
//                         marginBottom: '8px', 
//                         fontSize: '16px',
//                         borderBottom: '1px solid #1a6363',
//                         paddingBottom: '5px'
//                     }}>
//                         Overview
//                     </h6>
//                     <p style={{ 
//                         margin: '8px 0', 
//                         fontSize: '14px', 
//                         color: '#555',
//                         lineHeight: '1.5'
//                     }}>
//                         {ministry.detailedDescription}
//                     </p>
//                 </div>
                
//                 {/* Mission Statement */}
//                 <div style={{ margin: '15px 0' }}>
//                     <h6 style={{ 
//                         color: '#1a6363', 
//                         marginBottom: '8px', 
//                         fontSize: '16px',
//                         borderBottom: '1px solid #1a6363',
//                         paddingBottom: '5px'
//                     }}>
//                         Our Mission
//                     </h6>
//                     <p style={{ 
//                         margin: '8px 0', 
//                         fontSize: '14px', 
//                         color: '#555',
//                         lineHeight: '1.5',
//                         fontStyle: 'italic'
//                     }}>
//                         {ministry.mission}
//                     </p>
//                 </div>
                
//                 {/* Meeting Schedule */}
//                 <div style={{ margin: '15px 0' }}>
//                     <h6 style={{ 
//                         color: '#1a6363', 
//                         marginBottom: '8px', 
//                         fontSize: '16px',
//                         borderBottom: '1px solid #1a6363',
//                         paddingBottom: '5px'
//                     }}>
//                         Meeting Schedule
//                     </h6>
//                     <p style={{ 
//                         margin: '8px 0', 
//                         fontSize: '14px', 
//                         color: '#555',
//                         lineHeight: '1.5'
//                     }}>
//                         {ministry.meetingSchedule}
//                     </p>
//                 </div>
                
//                 {/* Activities */}
//                 <div style={{ margin: '15px 0' }}>
//                     <h6 style={{ 
//                         color: '#1a6363', 
//                         marginBottom: '8px', 
//                         fontSize: '16px',
//                         borderBottom: '1px solid #1a6363',
//                         paddingBottom: '5px'
//                     }}>
//                         Our Activities
//                     </h6>
//                     <div style={{ 
//                         margin: '8px 0', 
//                         fontSize: '14px', 
//                         color: '#555',
//                         lineHeight: '1.5',
//                         whiteSpace: 'pre-line'
//                     }}>
//                         {ministry.activities}
//                     </div>
//                 </div>
                
//                 {/* Requirements */}
//                 <div style={{ margin: '15px 0' }}>
//                     <h6 style={{ 
//                         color: '#1a6363', 
//                         marginBottom: '8px', 
//                         fontSize: '16px',
//                         borderBottom: '1px solid #1a6363',
//                         paddingBottom: '5px'
//                     }}>
//                         Participation Requirements
//                     </h6>
//                     <div style={{ 
//                         margin: '8px 0', 
//                         fontSize: '14px', 
//                         color: '#555',
//                         lineHeight: '1.5',
//                         whiteSpace: 'pre-line'
//                     }}>
//                         {ministry.requirements}
//                     </div>
//                 </div>
                
//                 {/* Leaders Section */}
//                 <div style={{ margin: '15px 0' }}>
//                     <h6 style={{ 
//                         color: '#1a6363', 
//                         marginBottom: '8px', 
//                         fontSize: '16px',
//                         borderBottom: '1px solid #1a6363',
//                         paddingBottom: '5px'
//                     }}>
//                         Ministry Leaders
//                     </h6>
//                     {ministry.leaders?.map((item) => (
//                         <div key={item.leaderID} style={{
//                             display: "flex",
//                             flexDirection: "column",
//                             alignItems: "flex-start",
//                             marginBottom: "12px",
//                         }}>
//                             <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
//                                 <span style={{
//                                     fontFamily: "Arial, sans-serif",
//                                     fontSize: "15px",
//                                     color: "#1a6363",
//                                     fontWeight: 500
//                                 }}>
//                                     {item.admin}
//                                 </span>
//                             </div>
//                             <span style={{
//                                 fontFamily: "Arial, sans-serif",
//                                 fontSize: "14px",
//                                 color: "#555",
//                                 marginTop: "4px"
//                             }}>
//                                 Contact: {item.adminphone}
//                             </span>
//                         </div>
//                     ))}
//                 </div>
                
//                 {/* Action Buttons */}
//                 <div style={{ marginTop: '20px' }}>
//                     {ministry.joined ? (
//                         <button onClick={handleLeave} style={{
//                             backgroundColor: '#ff4d4d',
//                             color: '#ffffff',
//                             border: 'none',
//                             borderRadius: '5px',
//                             padding: '12px 20px',
//                             cursor: 'pointer',
//                             width: '100%',
//                             fontSize: '15px',
//                             fontWeight: '500'
//                         }}>
//                             Request to Leave Ministry
//                         </button>
//                     ) : ministry.pendingJoin ? (
//                         <button style={{
//                             backgroundColor: '#1a6363',
//                             color: '#ffffff',
//                             border: 'none',
//                             borderRadius: '5px',
//                             padding: '12px 20px',
//                             cursor: 'pointer',
//                             width: '100%',
//                             opacity: 0.7,
//                             fontSize: '15px',
//                             fontWeight: '500'
//                         }}>
//                             Join Request Pending
//                         </button>
//                     ) : ministry.PendingLeave ? (
//                         <button style={{
//                             backgroundColor: '#1a6363',
//                             color: '#ffffff',
//                             border: 'none',
//                             borderRadius: '5px',
//                             padding: '12px 20px',
//                             cursor: 'pointer',
//                             width: '100%',
//                             opacity: 0.7,
//                             fontSize: '15px',
//                             fontWeight: '500'
//                         }}>
//                             Leave Request Pending
//                         </button>
//                     ) : (
//                         <button onClick={handleJoin} style={{
//                             backgroundColor: '#1a6363',
//                             color: '#ffffff',
//                             border: 'none',
//                             borderRadius: '5px',
//                             padding: '12px 20px',
//                             cursor: 'pointer',
//                             width: '100%',
//                             fontSize: '15px',
//                             fontWeight: '500'
//                         }}>
//                             Join This Ministry
//                         </button>
//                     )}            
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default MinistryProfile;